module.exports = __webpack_public_path__ + "img/icon-theft-gray.676c698d.svg";